import { useState } from 'react'
import ReactHowler from 'react-howler'
import { HeaderTitle, MobileTitle } from '../../components/Title'
import ReactGA from 'react-ga4'
import { AllCharacteres } from './AllCharacters'
import { CharPhantoms } from './CharPhantoms'

export const Characters = () => {
    const [hover, setHover] = useState(false)
    const [isVoiceOn, setIsVoiceOn] = useState(false)

    const [voice, setVoice] = useState(1)
    const setCurrent = (e) => {
        setVoice(e)
    }
    const [showModal, setShowModal] = useState(false)
    const [activeCharTab, setActiveCharTab] = useState('characters')
    const [modalImage, setModalImage] = useState()
    const handleOpenModal = (imagepath) => {
        setModalImage(imagepath)
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

  
    return (
        <>
            <div className='md:pt-0 md:mt-20'>
                <div className='py-12 w-full text-center mx-auto'>
                    <span className=' relative pt-2'>
                        <h1 className='md:hidden text-gradient-title text-xlg font-pop inline-block'>Characters</h1>{' '}
                    </span>
                </div>
                {isVoiceOn && (
                    <ReactHowler
                        src={`${process.env.PUBLIC_URL}/voice/charvoice-0${voice}.wav`}
                        playing={isVoiceOn}
                        volume={0.3}
                        loop={false}
                        onEnd={() => setIsVoiceOn(false)}
                    />
                )}{' '}
                <div className='flex flex-row gap-4 justify-center mt-12 md:mt-0 px-2 max-w-[600px] mx-auto'>
                    <div>
                        {' '}
                        <button>
                            <span className='relative inline-block'>
                                <img
                                    onClick={() => {
                                        setActiveCharTab('characters')
                                    }}
                                    className={`${
                                        activeCharTab === 'characters' && 'brightness-150'
                                    } hover:brightness-150 duration-300 mx-auto`}
                                    src={`${process.env.PUBLIC_URL}/images/characters/header-characters.webp`}
                                    alt='characters'
                                />{' '}
                            </span>
                        </button>{' '}
                    </div>{' '}
                    <div>
                        <button>
                            {' '}
                            <span className='relative inline-block '>
                                <img
                                    onClick={() => {
                                        setActiveCharTab('phantoms')
                                    }}
                                    className={`${
                                        activeCharTab === 'phantoms' && 'brightness-150'
                                    } hover:brightness-150 duration-300 mx-auto `}
                                    src={`${process.env.PUBLIC_URL}/images/characters/header-phantoms.webp`}
                                    alt='phantoms'
                                />{' '}
                            </span>
                        </button>{' '}
                    </div>
                </div>
                {activeCharTab === 'characters' ? <AllCharacteres /> : <CharPhantoms />}{' '}
                <div className='flex flex-row gap-4 justify-center mt-12 md:mt-0 mb-20 px-2 max-w-[600px] mx-auto'>
                    <div>
                        {' '}
                        <button>
                            <span className='relative inline-block'>
                                <img
                                    onClick={() => {
                                        scrollToTop()
                                        setActiveCharTab('characters')
                                    }}
                                    className={`${
                                        activeCharTab === 'characters' && 'brightness-150'
                                    } hover:brightness-150 duration-300 mx-auto`}
                                    src={`${process.env.PUBLIC_URL}/images/characters/header-characters.webp`}
                                    alt='characters'
                                />{' '}
                            </span>
                        </button>{' '}
                    </div>{' '}
                    <div>
                        <button>
                            {' '}
                            <span className='relative inline-block '>
                                <img
                                    onClick={() => {
                                        scrollToTop()
                                        setActiveCharTab('phantoms')
                                    }}
                                    className={`${
                                        activeCharTab === 'phantoms' && 'brightness-150'
                                    } hover:brightness-150 duration-300 mx-auto`}
                                    src={`${process.env.PUBLIC_URL}/images/characters/header-phantoms.webp`}
                                    alt='phantoms'
                                />{' '}
                            </span>
                        </button>{' '}
                    </div>
                </div>{' '}
            </div>
        </>
    )
}
